import type { ReactNode } from 'react';

import { Account } from '../../auth/types';
import { api } from '../api';
import { SubscriptionPayment } from './SubscriptionPayment';
import { Button } from '../../ui/components/Button';
import { SubscriptionInfo } from './SubscriptionInfo';

type Props = {
  account: Account
}

const Wrapper = ({ children }: { children: ReactNode[] | ReactNode }) => (
  <div className='p-4 grow flex flex-col'>
    { children }
  </div>
);

export const SubscriptionDetails = ({ account }: Props) => {

  const subscription = api.useGetSubscriptionQuery();

  if (account.unlimited) {
    return (
      <Wrapper>
        <p>
          Good news! Your account has <b>unlimited JustWords Premium</b> status.
          This means that you can use all the features of JustWords Premium
          without needing a subscription.
        </p>
      </Wrapper>
    );
  }

  if (subscription.error && 'status' in subscription.error && subscription.error?.status === 404) {
    // There is no subscription for this user
    return <SubscriptionPayment />;
  }

  if (subscription.error || (!subscription.data && !subscription.isLoading)) {
    // We couldn't retrieve the subscription, if it exists
    return (
      <>
        <p className='my-8'>We couldn't retrieve your subscription details at this time.</p>
        <Button
          grow={false}
          onClick={subscription.refetch}
        >
          Try again
        </Button>
      </>
    );
  }

  if (subscription.data) {
    return <SubscriptionInfo subscription={subscription.data!} />;
  }

};
